<template>
  <v-card flat>
    <v-radio-group v-model="valueComputed" :mandatory="$route.name !== 'qr.qr.id.edit'" hide-details row>
      <v-radio v-for="(item, i) in components" :key="i" :value="item.name" class="ms-8 mb-4">
        <template v-slot:label>
          <v-img :src="frames.find(obj => obj.name === item.name).src" class="ms-2" contain height="100" width="100"/>
        </template>
      </v-radio>
    </v-radio-group>
  </v-card>
</template>

<script>
export default {
  name: "themeSelector2",

  props: {
    value: String,
    components: Array,
    frames: []
  },

  data: () => ({}),

  computed: {
    valueComputed: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val)
      }
    }
  }
}
</script>

<style scoped>
.v-input >>> .v-label {
  margin: 0;
}

.v-input >>> .v-input--selection-controls__input {
  align-self: flex-start;
}
</style>